import { render, staticRenderFns } from "./authorization4.vue?vue&type=template&id=2243d328&scoped=true&"
import script from "./authorization4.vue?vue&type=script&lang=js&"
export * from "./authorization4.vue?vue&type=script&lang=js&"
import style0 from "./authorization4.vue?vue&type=style&index=0&id=2243d328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243d328",
  null
  
)

export default component.exports